import FrontOurTeamCards from "@/Components/Front/Blocks/FrontOurTeamCards";
import ServiceDescription from "@/Components/Front/Blocks/ServiceDescription";
import ServicesHero from "@/Components/Front/Blocks/ServicesHero";
import WebpImage from "@/Components/Front/Blocks/WebpImage";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import FrontLayout from "@/Layouts/System/FrontLayout";
import { Link } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import AcfFeaturesList from "@/Components/Front/Blocks/Acf/AcfFeaturesList";
import FrontSeoMetaTags from "@/Components/Front/Partials/FrontSeoMetaTags";

const LandSalesAndPurchases = ({ seo, agents }) => {
    const { t, i18n } = useTranslation();

    return (
        <FrontLayout breadcrumbs={[
            { title: t('breadcrumbs.services'), current: false, href: resolveLocaleRoute('front.services', null, i18n.resolvedLanguage) },
            { title: t('breadcrumbs.landSalesAndPurchases'), current: true },
        ]}>
            <FrontSeoMetaTags seo={seo}/>
            <section>
                <ServicesHero icon={'/storage/icons/service-pin-icon.svg'} title={t('services.landSalesAndPurchasesHeading')} />
                <ServiceDescription contentKey={'services.landSalesAndPurchasesDescription'} lng={i18n.resolvedLanguage} components={{1: <Link href={resolveLocaleRoute('front.contact' , null, i18n.resolvedLanguage)}/>}}>
                    <WebpImage
                        className='rounded-10 mt-5'
                        sources={[
                            {
                                width: 768,
                                path: '/storage/images/sprzedaz-i-zakup-gruntow-size-530',
                                mime: '/jpg'
                            },
                            {
                                width: 1,
                                path: '/storage/images/sprzedaz-i-zakup-gruntow',
                                mime: 'jpg'
                            }
                        ]}
                        alt={t('services.landSalesAndPurchasesHeading')}
                        fallback={`/storage/images/sprzedaz-i-zakup-gruntow.jpg`}
                        seo={{
                            width: 520,
                            height: 287
                        }}
                    />
                </ServiceDescription>
            </section>
            
            <section>
                <Container>
                    <Row>
                        <AcfFeaturesList
                            blockSpacing="xl:mb-c120 lg:mb-20 md:mb-15 mb-10"
                            list={t('services.landSalesAndPurchasesFeaturesList', {returnObjects: true})}
                        />
                    </Row>
                </Container>
            </section>

            <section className="xl:mb-c120 lg:mb-25 md:mb-20 mb-15">
                <FrontOurTeamCards agents={agents}/>
            </section>
        </FrontLayout>
    )
}

export default LandSalesAndPurchases;